// extracted by mini-css-extract-plugin
export default {"badge":"SyncPendingButton__badge___URzPs","disabled":"SyncPendingButton__disabled___fEhY2"};